import React from 'react';
import { Button } from 'semantic-ui-react';
import OutboundLink from '../../../../../../atoms/OutboundLink/OutboundLink';
import PublishModalContent from '../../../PublishModalContent/PublishModalContent';
import './LaunchDashboardContent.css';
var defaultProps = {
  show: false
};
export default function LaunchDashboardContent(_ref) {
  var show = _ref.show;
  return /*#__PURE__*/React.createElement(PublishModalContent, {
    show: show,
    backButtonText: "Step 1/1",
    headerText: "Final Step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "launch-clover-fisherman-dashboard"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-text instructions"
  }, "In order to select a domain for your website and complete on-boarding, please log in to your Fisherman Dashboard."), /*#__PURE__*/React.createElement(OutboundLink, {
    to: process.env.DASHBOARD_URL,
    className: "checkout-button-enabled centered-button",
    label: "Launch Fisherman Dashboard",
    as: Button
  })));
}
LaunchDashboardContent.defaultProps = defaultProps;